<template>
  <el-row :class="decoration">
    <!-- <p>{{decoration}}</p> -->
    <el-col :sm="hideInfo ? 12 : 8">
      <el-tag
        type="primary"
        :title="
          vehicle.type +
          ':' +
          vehicle.capacity +
          (vehicle.transits.avg_diff
            ? ' transfers monthly diff ' + vehicle.transits.avg_diff
            : '')
        "
      >
        <fa :icon="icon(vehicle)"></fa>
      </el-tag>
      <span :title="JSON.stringify(vehicle.weight.log)">{{
        vehicle.name
      }}</span>
    </el-col>

    <!-- <el-col :sm="2" title="Transfers differense (season/month)">
      <el-badge class="item">
        <i class="material-icons">transfer_within_a_station</i>
      </el-badge>
    </el-col>-->
    <template v-if="vehicle.active">
      <el-col
        :sm="8"
        class="trackv"
        :title="vehicle.nowis.ppname"
        v-if="!hideInfo"
      >
        <div v-if="vehicle.nowis" :class="vehicle.nowis.status">
          <span class="el-badge__content el-badge__content">{{
            vehicle.nowis.resort
          }}</span>
          <template>
            <i class="material-icons small">location_searching</i>
            <!-- <span>{{vehicle.nowis.ppname}}</span> -->
            <i
              class="material-icons small"
              v-if="vehicle.nowis.status == 'MOVING'"
              >fast_forward</i
            >
            <i
              class="material-icons small"
              v-if="vehicle.nowis.status == 'OFFLINE'"
              >signal_wifi_off</i
            >
            <span v-if="vehicle.nowis.status == 'STOPED'">
              <i class="material-icons small">stop</i>
              {{ formatUnxTime(vehicle.nowis.timestopped, true) }}
            </span>
          </template>
        </div>
      </el-col>

      <el-col :sm="4">
        <el-button
          title="To Go/Planned  (routes)"
          :class="vehicle.ended.routesToGo ? 'going' : ''"
          @click.stop.prevent="$emit('viewVehicle', vehicle.id)"
          circle
        >
          {{ vehicle.ended.routesToGo }}
          <small>/{{ vehicle.ended.routesAssigned }}</small>
        </el-button>
      </el-col>
      <el-col
        style="font-size: 10px"
        v-if="vehicle.ended"
        :title="
          'Free at ' +
          (vehicle.ended ? formatUnxTime(vehicle.ended.lastDate) : '-')
        "
        :sm="hideInfo ? 8 : 4"
      >
        {{ vehicle.ended.lastLocCode }}
        <fa icon="clock"></fa>
        {{ vehicle.ended ? intToTime(vehicle.ended.freeTime) : "-" }}
      </el-col>
    </template>
    <!-- <p>{{vehicle.weight}}</p> -->
  </el-row>
</template>

<script>
import { fetchList } from "~/api/resource";
import { mapGetters } from "vuex";
import { decorator } from "babel-types";

export default {
  name: "routing-vehicle",
  props: {
    vehicleData: {
      default: null,
    },
    assignedRoutes: {
      default: 0,
    },
    hideInfo: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    vehicleData: {
      handler: function (newValue) {
        this.vehicle = newValue;
      },
      deep: true,
    },
  },
  methods: {
    icon(v) {
      // _log_("o,v,", v);
      if (!v) return "";
      var t = v.type;
      if (!t) {
        if (v.capacity) t = "normal";
        else t = "external";
      }
      const icons = {
        mini: "shuttle-van",
        MINI: "shuttle-van",
        medium: "bus",
        MEDIUM: "bus",
        normal: "bus-alt",
        NORMAL: "bus-alt",
        big: "bus-alt",
        BIG: "bus-alt",
        double: "subway",
        DOUBLE: "subway",
        external: "taxi",
      };
      if (!icons[t]) {
        console.error("missing icon for ", t);
        return "bus";
      }
      return icons[t];
    },
  },
  computed: {
    decoration() {
      var c = this.vehicle.active ? "vehicle-unit" : "vehicle-unit freezed";
      if (this.vehicle.weight && this.vehicle.weight.howBad)
        c += " bad-" + this.vehicle.weight.howBad;
      else c += " noway";
      return c;
    },
  },
  data() {
    return {
      vehicle: null,
    };
  },
  created() {
    this.vehicle = this.vehicleData;
  },
};
</script>

<style>
.levelC .vehicle-unit {
  background-color: rgba(153, 123, 123, 0.2);
  opacity: 0.9;
}
.vehicle-unit {
  border: 1px solid indigo;
  padding: 3px;
  border-radius: 3%;
}
.vehicle-unit.freezed {
  background-color: rgba(92, 19, 19, 0.781) !important;
  color: white;
}
.trackv {
  background-color: aqua;
  font-size: 10px;
  border-radius: 5px;
  border: 1px solid white;
  margin-top: 5px;
}
.trackv .MOVING {
  background-color: indianred !important;
  color: white !important;
  font-size: 10px;
}
.trackv .STOPED {
  background-color: rgb(92, 141, 205) !important;
  color: white !important;
}
.trackv .OFFLINE {
  background-color: rgba(119, 121, 124) !important;
  color: white !important;
}
.bad-10 {
  font-weight: bold;
  color: white;
  background-color: rgba(6, 107, 50) !important;
}
.bad-20 {
  font-weight: bold;
  color: white;
  background-color: rgba(6, 107, 50, 0.2) !important;
}
.bad-30 {
  color: white;
  background-color: rgba(6, 107, 50, 0.4) !important;
}
.bad-40 {
  background-color: rgba(153, 123, 123, 0.7) !important;
}
.bad-50 {
  background-color: rgba(153, 123, 123, 0.75) !important;
}
.bad-60 {
  background-color: rgba(153, 123, 123, 0.85) !important;
}

.vehicle-unit .going {
  background-color: darkgreen;
  color: white;
}
</style>

